module.exports = __webpack_public_path__ + "img/NL343.7a4030bf.png";